export default __webpack_public_path__ + "static/media/anniversary5.aefd49bb.webp";